import AnimaticStoryBase from './AnimaticStoryBase';

/*
  These could probaby be flattened into AnimaticStoryBase with params,
  But I have a feeling they'll need some bespoke stuff, so leaving as seperate class
*/

export default class AnimaticStoryIntro extends AnimaticStoryBase {
  init({ watched }) {
    this.watched = watched;
    this.assets = 'outro';

    // local assets with vo
    this.localAsssets = {
      assets: [
        {
          type: 'audiosprite',
          key: 'story_vo',
          urls: [
            '../locale/' + this.game.language + '/audio/story_outro_vo.m4a',
            '../locale/' + this.game.language + '/audio/story_outro_vo.ogg',
            '../locale/' + this.game.language + '/audio/story_outro_vo.mp3',
          ],
          jsonURL: '../locale/' + this.game.language + '/audio/story_outro_vo.json',
          jsonData: null,
          autoDecode: true,
        },
      ],
    };
  }

  handleComplete() {
    this.game.gameController.triggerWorldState();
  }
}



// WEBPACK FOOTER //
// ./js/app/states/AnimaticStoryEnd.js